// =========================
// EVENT VIEW
// =========================
import App from './../../App';
import { html, render } from 'lit-html';
import { gotoRoute } from './../../Router';
import Auth from './../../Auth';
import Utils from './../../Utils';

//This is the EventView class that handles displaying a single event's details
// It fetches the event data from the server and renders it on the page
class EventView {
  constructor() {
    this.event = null;
  }

  // This method initializes the view by fetching the event data based on the ID from the URL
  async init() {
    const urlParams = new URLSearchParams(window.location.search);
    const eventId = urlParams.get('id');

    if (!eventId) return;

    try {
      const res = await fetch(`${App.apiBase}/event/${eventId}`);
      if (!res.ok) throw new Error('Event not found');

      this.event = await res.json();
    } catch (err) {
      console.error('Error loading event:', err);
      gotoRoute('/');
      return;
    }

    document.title = `PopIn – ${this.event.title}`;
    this.render();
    Utils.pageIntroAnim();
  }

  // This method renders the event details on the page
  render() {
    const e = this.event;
    if (!e) return;

    const host = e.hostId || {};
    const hostName = `${host.firstName || ''} ${host.lastName || ''}`;
    const eventImage = e.eventImage
      ? `${App.apiBase}/uploads/${e.eventImage}`
      : `${App.apiBase}/static/default-profile-event.png`;

    const template = html`
      <div class="layout">
        <popin-side-nav></popin-side-nav>
        <div class="main-area">
          <popin-top-bar .user=${Auth.currentUser}></popin-top-bar>
          <div class="main-content">
            <div class="profile-header">
              <img
                src="${eventImage}"
                alt="Event Image"
                class="profile-image"
              />
              <div class="profile-info">
                <h1>${e.title}</h1>
                <h3 class="location">${e.location}</h3>
                <hr />
                <p class="bio">${e.description}</p>
                <p><strong>Category:</strong> ${e.category}</p>
                <p>
                  <strong>Date & Time:</strong> ${new Date(
                    e.dateTime
                  ).toLocaleString()}
                </p>
                <p><strong>Host:</strong> ${hostName}</p>
              </div>
            </div>

            <div class="profile-tabs">
              <sl-tab-group placement="top">
                <sl-tab slot="nav" panel="details">DETAILS</sl-tab>
                <sl-tab slot="nav" panel="attendees">ATTENDEES</sl-tab>
                <sl-tab slot="nav" panel="comments">COMMENTS</sl-tab>

                <sl-tab-panel name="details">
                  <p><strong>Visibility:</strong> ${e.visibility}</p>
                  <p>
                    <strong>Created At:</strong> ${new Date(
                      e.createdAt
                    ).toLocaleDateString()}
                  </p>
                  <p>
                    <strong>Updated At:</strong> ${new Date(
                      e.updatedAt
                    ).toLocaleDateString()}
                  </p>
                </sl-tab-panel>

                <sl-tab-panel name="attendees">
                  ${e.attendees && e.attendees.length > 0
                    ? html`
                        <ul>
                          ${e.attendees.map(
                            (a) => html`<li>${a.firstName} ${a.lastName}</li>`
                          )}
                        </ul>
                      `
                    : html`<p>No attendees yet.</p>`}
                </sl-tab-panel>

                <sl-tab-panel name="comments">
                  ${e.comments && e.comments.length > 0
                    ? html`
                        <ul>
                          ${e.comments.map((c) => html`<li>${c}</li>`)}
                        </ul>
                      `
                    : html`<p>No comments yet.</p>`}
                </sl-tab-panel>
              </sl-tab-group>
            </div>
          </div>
        </div>
      </div>
    `;

    render(template, App.rootEl);
  }
}

export default new EventView();
